import { scroller } from 'react-scroll';
import { FOOTER } from './constants';
import { Location, NavigateFunction } from 'react-router-dom';

const scrollTarget = (target: string, ease: boolean) => {
  const config = {
    spy: true,
    smooth: ease,
    duration: ease ? 1000 : 0,
  };

  scroller.scrollTo(target, config);
};

const scrollToPage = async (
  target: string,
  location: Location,
  navigate: NavigateFunction,
  forceNavigateToTargetPage = false
) => {
  const isHome = location.pathname === '/';
  const shouldNavigateHome = !isHome && target !== FOOTER;

  if (forceNavigateToTargetPage) {
    await navigate(`/${target}`);
    setTimeout(() => scrollTarget(target, false), 0);
  } else if (shouldNavigateHome) {
    await navigate('/');
    setTimeout(() => scrollTarget(target, false), 0);
  } else {
    scrollTarget(target, true);
  }
};

export default scrollToPage;
